module.exports = __webpack_public_path__ + "img/nvidia.b80ad42d.png";